import UpdateUserApiKey
    from "../../../../components/@userApiKeys/userApiKeys/UpdateUserApiKey";

import {routeTypes} from "../../../../hooks/useSystemRoutes";

export default function UserApiKeyUpdatePage () {

    return UpdateUserApiKey ({
        routeType: routeTypes.admin
    });
}       